import {anvPermissions} from "@/utilities/permissions/Permissions";
import {useSystemStore} from "@/stores/system/SystemStore";

export default class PermissionService {
    /*
        gets identifier of policy to look for, and checks if the user has one of the roles listed in the policy-roles

        returns false when user is not set
     */
    public static userHasPermission(policyName:string):boolean{
        const systemStore = useSystemStore();

        const roleList = this.getRolesFromPolicyList(policyName);

        if (systemStore.user === null || systemStore.user === undefined) return false;

        const roles = systemStore.user.roles;

        return roles.some((i:any) => roleList.includes(i));
    }

    /* --- PRIVATE  --- */

    private static getRolesFromPolicyList(policyName:string):Array<string>{
        const foundPolicy = anvPermissions.find((i:any) => i.Name === policyName);

        if (foundPolicy === undefined) return new Array<string>(); //TODO error handling?

        return foundPolicy.Roles.split(/,\s*/g);
    }
}